import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileMov"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 6.75L19.5 16.5L18 6.75H16.5L18.39 17.25H20.61L22.5 6.75H21ZM13.5 17.25H10.5C9.67157 17.25 9 16.5784 9 15.75V8.25C9 7.42157 9.67157 6.75 10.5 6.75H13.5C14.3284 6.75 15 7.42157 15 8.25V15.75C15 16.5784 14.3284 17.25 13.5 17.25ZM10.5 8.25V15.75H13.5V8.25H10.5ZM6 6.75L4.8675 10.5L4.5 11.985L4.155 10.5L3 6.75H1.5V17.25H3V11.25L2.88 9.75L3.315 11.25L4.5 14.7225L5.685 11.25L6.12 9.75L6 11.25V17.25H7.5V6.75H6Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileMov.vue"]]);
